"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const mui_1 = require("tss-react/mui");
const uuid_1 = require("uuid");
const react_device_detect_1 = require("react-device-detect");
const react_tippy_1 = require("react-tippy");
require("react-tippy/dist/tippy.css");
const Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
const styles_1 = require("./styles");
const useStyle = (0, mui_1.makeStyles)()(styles_1.styles);
const QTip = (_a) => {
    var { children, title, html, className, wrapId, wrapOnly, popperProps, arrowClass, noTippyTip, enableOnMobile, placement, position } = _a, other = __rest(_a, ["children", "title", "html", "className", "wrapId", "wrapOnly", "popperProps", "arrowClass", "noTippyTip", "enableOnMobile", "placement", "position"]);
    const [id, setId] = React.useState(wrapId || (0, uuid_1.v4)());
    const [overflow, setOverflow] = React.useState(false);
    const wrapRef = React.useRef(null);
    const { classes } = useStyle();
    const isElementOverflow = (element) => element && element.clientWidth < element.scrollWidth;
    const checkOverflow = () => {
        let element = wrapRef.current || document.getElementById(`QtipId:${id}`);
        if (element && element.children) {
            element = element.firstElementChild;
        }
        const hasOverflow = isElementOverflow(element);
        setOverflow(hasOverflow);
    };
    React.useEffect(() => {
        if (wrapOnly) {
            checkOverflow();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [wrapOnly, id]);
    React.useEffect(() => {
        setId(wrapId || (0, uuid_1.v4)());
    }, [wrapId]);
    if ((!react_device_detect_1.isMobile || enableOnMobile) && ((html || (typeof title === 'string' && title.trim().length > 0)) && (!wrapOnly || overflow))) {
        return html && !noTippyTip ? (
        // @ts-expect-error No overload matches this call.
        <react_tippy_1.Tooltip animation="fade" id={`tooltip-id:${id}`} theme="transparent" hideOnClick size="small" duration={200} distance={15} position={placement || 'bottom-end'} title={html ? null : title || ''} html={html} delay={500} {...other}>
        <span style={{ height: '100%' }} id={`QtipId:${id}`} className={className} ref={wrapRef}>
          {children}
        </span>
      </react_tippy_1.Tooltip>) : (<Tooltip_1.default enterDelay={500} id={`tooltip:${id}`} leaveDelay={200} placement={position || 'bottom-end'} title={html || title || ''} classes={{ tooltip: classes.tooltip, arrow: arrowClass }} PopperProps={popperProps} {...other}>
        <span id={`QtipId:${id}`} className={className} ref={wrapRef}>
          {children}
        </span>
      </Tooltip_1.default>);
    }
    return (<span id={`QtipId:${id}`} className={className} ref={wrapRef}>
      {children}
    </span>);
};
exports.default = QTip;
